import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import { Text } from "@/elements"

export const ChatWarningText = () => {
  return (
    <div className="flex w-full flex-row justify-center px-6 py-4">
      <ExclamationTriangleIcon className="mr-2 size-[18px] stroke-fg-2" />
      <Text variant="caption" className="text-center text-fg-2">
        To protect your account, always communicate through the Nova website or app
      </Text>
    </div>
  )
}
